import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop/Spacing'
import { Param } from '@ucheba/ui/components/Param/desktop'
import { ExternalLogo } from '@ucheba/ui/components/ExternalLogo/desktop'
import { IItemOfOlympiads } from '@ucheba/store/olympiads/types'
import { Text } from '@ucheba/ui/components/Text/desktop'
import SC from '../base/OlympiadsListItem.styles'
import { useImageColWidth, useOlympiadHref, useOlympiadsListItemCore } from '../bll'
import { imageWidth } from '../contants'

const { Block } = SC

/** Олимпиада */
const OlympiadsListItem: FC<IItemOfOlympiads> = (props) => {
  const {
    isDivider = true,
    id,
    name,
    classFrom,
    classTo,
    logo,
    stages,
    levelFrom,
    levelTo,
  } = props

  const href = useOlympiadHref(id)
  const imageColWidth = useImageColWidth(imageWidth)
  const { dates, datesType, level, classes } = useOlympiadsListItemCore({
    stages,
    classTo,
    classFrom,
    levelFrom,
    levelTo,
  })

  return (
    <Block isDivider={isDivider}>
      <Grid justifyContent='space-between' nowrap>
        <GridCol shrink='initial' width='auto'>
          <Param entity={dates} clarification={datesType} spacing='xxsmall' />

          <Spacing spacing='usmall' />

          <a href={href}>
            <Text color='blue' fontSize='h3' lineHeight='h3' fontWeight='bold'>
              {name}
            </Text>
          </a>

          <Spacing spacing='usmall' />

          {(level || classes) && (
            <Grid spacing='xxsmall'>
              {level && (
                <GridCol width='auto'>
                  <Param entity={level?.entity} clarification={level?.clarification} />
                </GridCol>
              )}

              {classes && (
                <GridCol width='auto'>
                  <Param entity={classes.entity} clarification={classes.clarification} />
                </GridCol>
              )}
            </Grid>
          )}
        </GridCol>

        <GridCol width={imageColWidth}>
          <ExternalLogo
            logo={logo}
            alt={name}
            height='unset'
            maxHeight='80px'
            maxWidth='64px'
            href={href}
          />
        </GridCol>
      </Grid>
    </Block>
  )
}

export { OlympiadsListItem }
export default memo(OlympiadsListItem)
